@if(properties().title) {
<div class="modal-header modal-pepsico-header">
  <h1 #title class="modal-title fs-5"></h1>
</div>
}

<div class="modal-body text-center">
  <div class="order-tracking-unique">
    <div class="order-tracking-container-unique jf-center">
      @if(properties().body) {
      <p #body class="mb-4"></p>
      }
    </div>
    <div class="d-flex jf-center">
      <button type="button" class="btn btn-primary perfilbtn-pep" (click)="closeModal()">
        Cerrar
      </button>
      @for (button of properties().buttons; track $index) {
      <button #btnAction type="button" class="ms-2 btn" (click)="executeAction(button.action)"></button>
      }
    </div>
  </div>
</div>